<template>
  <div v-if="currentUser.role == 'admin'">
    <div class="CommentsLink" @click="showPopup()"><div class="commentsText">Обсуждение </div> <img class="commentIcon" src="/img/icon-comments.png" height="15" width="20"> <div class="commentsNum">{{ card.comments_count }}</div></div>

    <div class="CommentsPopup" v-show="popupVisible">
      <div class="PopUpComments">
        <div class="PopUpFon" @click="hidePopup()"></div>
        <div class="PopUpComPanel">
          <div class="PopUpComBlock">
            <div class="ComName">{{ card.name_big }}</div>
            <div class="ComDopName">{{ card.name_small }}</div>
            <div class="ComNum">{{ card.comments_count }}!</div>
            <div class="AuthorBlock">
              <div class="MAva" :style='{ backgroundImage: `url(${card.author.avatar_preview_40})` }'></div>
              <div class="Redactor">Модератор: {{ card.author.name }}</div>
              <div class="MailRedactor" @click="showWriteMessagePopup" v-if="!authorized || card.author.id != currentUser.id">Написать сообщение</div>
            </div>
            <div class="PopUpClose" @click="hidePopup()"></div>
            <div class="Razdelitel"></div>

            <div class="Comment" v-for="comment in comments"><div class="ComAuthor">
                <div class="CommentAva" :style='{ backgroundImage: `url(${comment.author.avatar_preview_40})` }'></div>
                <div class="CommentName">{{ comment.author.name }}</div>
                <div class="CommentDate">{{ comment.date }}</div>
                <div class="CommentAnswer" v-if="comment.answer_to_user">{{ comment.answer_to_user.name }}</div>
                <div class="CommentDelete" v-if="allowDelete(comment)" @click="deleteComment(comment)" />
              </div>
              {{ comment.text }}
            </div>

            <div class="CommentForm" v-if="authorized">
              <form @submit.prevent="createComment">
                <input v-model="newCommentText" />
                <input type="submit" class="AddComment" value="Добавить" />
              </form>
            </div>
            <div v-if="!authorized">
              Необходимо авторизоваться, чтобы оставить комментарий.
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import { mapGetters } from 'vuex';
import { API_ROOT } from "@/utils/api_root";

export default {
  props: {
    cardId: Number,
    card: { type: Object, default: function() { return {}; } },
  },
  data() {
    return {
      popupVisible: false,
      newCommentText: null
    };
  },
  computed: {
    ...mapGetters(['currentUser', 'authorized']),
    comments() {
      return this.$store.getters.commentsByCard(this.cardId);
    },
  },
  methods: {
    showPopup() {
      this.popupVisible = true;
    },
    hidePopup() {
      this.popupVisible = false;
    },
    createComment() {
      console.log('Comments component createComment', this.newCommentText);
      if (isEmpty(this.newCommentText)) return;
      const params = { text: this.newCommentText,
                       author_id: this.currentUser.id,
                       answer_to_user_id: null };
      console.log('createComment params', params);

      this.$http.post(`${API_ROOT}/cards/${this.cardId}/comments.json`, {comment: params})
        .then(response => {
          console.log('createComment success', response, response.data);
          this.newCommentText = null;
          this.$store.commit('commentsByCard', {cardId: this.cardId, value: response.data});
        })
        .catch(error => {
          console.log('createComment error', error, error.response.data);
          this.flash('Ошибка сохранения', 'error');
        });
    },
    allowDelete(comment) {
      return this.currentUser.role == 'admin' ||
             (this.currentUser.role == 'moderator' && this.currentUser.id == this.card.author_id) ||
             (this.currentUser.id == comment.author_id);
    },
    deleteComment(comment) {
      this.$http.delete(`${API_ROOT}/cards/${this.cardId}/comments/${comment.id}`)
        .then(response => {
          console.log('deleteComment success', response, response.data);
          this.$store.commit('commentsByCard', {cardId: this.cardId, value: response.data});
          this.flash('Комментарий удален', 'success', {timeout: 3000});
        })
        .catch(error => {
          console.log('deleteComment error', error, error.response.data);
          this.flash('Ошибка удаления', 'error');
        });
    },
    showWriteMessagePopup() {
      this.hidePopup();
      this.$store.commit('onShowWriteMessagePopup', this.card.author);
    }
  },
  created: function() {
    this.$store.dispatch('loadCommentsByCard', this.cardId);
  }
};
</script>

<style>

.CommentsLink{
  position: relative;
  margin: 0px auto 0px;
  padding-top: 6px;
  top: 20px;
  width: 200px;
  height: 36px;
  border: 1px solid #c7c7c7;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
}

.CommentsLink:hover{
  background-color: #fff;
}

.commentsText{
  display: inline-table;
  color: #666666;
  padding-right: 10px;
  padding-bottom: 3px;
  font-family: "Roboto Condensed";
  font-size: 18px;
  text-align: center;
}

.commentIcon{
  display: inline-table;
  margin-top: 6px;
}

.commentsNum{
  display: inline-table;
  color: #acacac;
  padding-left: 10px;
  padding-bottom: 3px;
  font-family: "Roboto Condensed";
  font-size: 15px;
  text-align: center;
}

.PopUpComments{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.PopUpComPanel{
    position: absolute;
    left: 50%;
    top: 15%;
}

.PopUpComBlock{
  position: absolute;
  left: -300px;
  top: 0px;
  width: 600px;
  background-color: #dbdbdb;
  border-radius: 6px;
  -webkit-box-shadow: 0px 10px 40px #000;
  box-shadow: 0px 10px 40px #000;
}

.ComName{
  position: relative;
  left: 50px;
  margin-top: 30px;
  /* top: 30px; */
  font-family: 'Roboto Condensed', sans-serif;
  color: #000;
  font-weight: bold;
  font-size: 36px;
  line-height: 1.1;
}

.ComDopName{
  position: relative;
  left: 50px;
  /* top: 30px; */
  font-family: 'Roboto Condensed', sans-serif;
  color: #000;
  font-weight: 300;
  font-size: 20px;
  line-height: 1.1;
}

.ComNum{
  position: absolute;
  right: 50px;
  top: 30px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #505050;
  font-weight: 300;
  font-size: 20px;
}

.AuthorBlock{
  position: relative;
  left: 50px;
  margin-top: 20px;
  margin-bottom: 20px;
  /* top: 90px; */
  /* width: 310px; */
  height: 40px;
  border: 0px solid #888;
}

.MAva{
  position: absolute;
  left: 0px;
  top: 0px;
  height:40px;
  width: 40px;
  background-color: #888;
  background-repeat: no-repeat;
    background-size: cover;
}

.Redactor{
  position: absolute;
  left: 55px;
  top: 3px;
  font-family: 'Open Sans', sans-serif;
  color: #666;
  font-style: regular;
  font-size: 14px;
  border: 0px solid #cccccc;
}

.MailRedactor{
  position: absolute;
  left: 55px;
  top: 23px;
  font-family: 'Open Sans', sans-serif;
  color: #666;
  font-style: italic;
  font-size: 12px;
  border: 0px solid #cccccc;
  cursor: pointer;
}

.Razdelitel{
  position: relative;
  left: 30px;
  width: 540px;
  height: 1px;
  background-color: #888;
  margin-top: 20px;
  margin-bottom: 20px;
}

.Comment{
  position: relative;
  left: 40px;
  padding: 10px;
  margin-top: 10px;
  width: 500px;
  font-family: 'Open Sans', sans-serif;
  color: #666;
  font-size: 16px;
  border: 1px solid #b1b1b1;
  border-radius: 5px;
  background-color: #fff;
}

.ComAuthor{
  position: relative;
  width: 500px;
  height: 30px;
  margin-bottom: 5px;
  border: 0px solid #666;
}

.CommentAva{
  display: inline-table;
  width: 24px;
  height: 24px;
  background-color: #bdbdbd;
  background-size: cover;
}

.CommentName{
  position: relative;
  top: -5px;
  display: inline-table;
  padding-left: 10px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #505050;
  font-weight: normal;
  font-size: 16px;
}

.CommentDate{
  position: relative;
  top: -5px;
  display: inline-table;
  padding-left: 10px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #c7c7c7;
  font-weight: normal;
  font-size: 11px;
}

.CommentAnswer{
  cursor: pointer;
  position: absolute;
  right: 0px;
  top: 0px;
  width: 20px;
  height: 20px;
  background-image: url('/img/icon-answer.png');
  background-size: cover;
  opacity: 0.4;
}

.CommentAnswer:hover {
  opacity: 1;
}

.CommentForm{
  position: relative;
  left: 40px;
  padding: 10px;
  margin-top: 30px;
  width: 500px;
  font-family: 'Open Sans', sans-serif;
  color: #666;
  font-size: 16px;
  border: 1px solid #b1b1b1;
  border-radius: 5px;
  background-color: #fff;
}

.CommentDelete{
  cursor: pointer;
  width: 20px;
  height: 20px;
  background-image: url("/img/close.png");
  background-size: cover;
}

</style>
